<app-page>
  <app-page-title [title]="'ACTIVITY-LOG.OVERVIEW.TITLE' | translate">
  </app-page-title>

  <div class="top-cta">
    @if(eventId || personId || learningPathId) {
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      ></dx-button>
    }
  </div>

  <div class="activity-log-filters">
    <div class="activity-log-filters-dropdown">
      @if(!eventId && !learningPathId) {
        <dx-drop-down-box
          [value]="selectedEventIds"
          [inputAttr]="{ 'aria-label': 'Owner' }"
          valueExpr="id"
          displayExpr="name"
          [label]="'COMMON.FIELDS.TRAININGS' | translate"
          [dataSource]="allEventOptions"
          labelMode="floating"
          stylingMode="outlined"
          [disabled]="disableEventSelection"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [searchEnabled]="true"
              [dataSource]="allEventOptions"
              dataStructure="plain"
              keyExpr="id"
              selectionMode="multiple"
              showCheckBoxesMode="normal"
              [selectNodesRecursive]="false"
              displayExpr="name"
              [selectByClick]="true"
              (onItemSelectionChanged)="onEventSelected($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>

        <dx-drop-down-box
          [value]="selectedLearningPathIds"
          [inputAttr]="{ 'aria-label': 'Owner' }"
          valueExpr="id"
          displayExpr="name"
          [label]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
          [dataSource]="allLearningPathOptions"
          labelMode="floating"
          stylingMode="outlined"
          [disabled]="disableLearningPathSelection"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [searchEnabled]="true"
              [dataSource]="allLearningPathOptions"
              dataStructure="plain"
              keyExpr="id"
              selectionMode="multiple"
              showCheckBoxesMode="normal"
              [selectNodesRecursive]="false"
              displayExpr="name"
              [selectByClick]="true"
              (onItemSelectionChanged)="onLearningPathSelected($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      }

      @if(!personId) {
        <dx-drop-down-box
          [(value)]="selectedPersonIds"
          [inputAttr]="{ 'aria-label': 'Owner' }"
          valueExpr="id"
          displayExpr="name"
          [label]="'COMMON.FIELDS.EMPLOYEES' | translate"
          [dataSource]="allPersonOptions"
          labelMode="floating"
          stylingMode="outlined"
        >
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              [searchEnabled]="true"
              [dataSource]="allPersonOptions"
              dataStructure="plain"
              keyExpr="id"
              selectionMode="multiple"
              showCheckBoxesMode="normal"
              [selectNodesRecursive]="false"
              displayExpr="name"
              [selectByClick]="true"
              (onItemSelectionChanged)="onPersonSelected($event)"
            >
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      }
      
    </div>
    <dx-text-box
      class="search-input"
      icon="search"
      width="100%"
      labelMode="floating"
      stylingMode="outlined"
      [label]="'COMMON.SEARCH' | translate"
      [value]="searchText"
      valueChangeEvent="input"
      (onValueChanged)="onSearchInput($event)"
    >
      <dxi-button
        name="search"
        type="danger"
        location="before"
        [options]="{ 
          icon: 'search', 
          type: 'default',
          disabled: true 
        }"
      ></dxi-button>
    </dx-text-box>
  </div>

  <app-table
    [data]="activityLogsDataSource || []"
    [columns]="columns"
    [showSearch]="false"
    [pagingMode]="'server'"
    [disableSorting]="true"
    [disableFiltering]="true"
  ></app-table>
</app-page>